/**
 * SacramentsSanctuary 
 * www.santuariobasilicacoromoto.com
 * @author yadicksonvasquez@gmail.com
 * @updated 05/01/2020
 */

import React, { Component } from 'react';
import Header from './header';
import SanctuaryHistorySlider from './sanctuaryHistorySliders';
import Footer from './footer';
import sacramentoBautismo from '../img/sacramento-bautizos-santuario.jpg';
import sacramentoMatrimonio from '../img/sacramento-matromonio-santuario.jpg';
import { Helmet } from "react-helmet";


export default class SacramentsSanctuary extends Component {

    constructor(props) {
        super(props);
        let language = this.props.language != null ? this.props.language : "es";
        let onLanguageChange = this.props.onLanguageChange != null ? this.props.onLanguageChange : null;
        if (sessionStorage.getItem('language') !== null) {
            this.state = { lang: sessionStorage.getItem('language'), eventChangeLanguage: onLanguageChange };
        }
        else {
            this.state = { lang: language, eventChangeLanguage: onLanguageChange };
        }
        this.refreshLanguage = this.refreshLanguage.bind(this);
    }

    componentDidMount() {
        if (sessionStorage.getItem('language') !== null) {
            if (this.state.eventChangeLanguage !== null && typeof this.state.eventChangeLanguage !== "undefined") {
                this.setState({ lang: sessionStorage.getItem('language') });
                sessionStorage.setItem('language', sessionStorage.getItem('language'));
                this.state.eventChangeLanguage(sessionStorage.getItem('language'));
            }
        }
    }

    refreshLanguage(value) {
        if (value !== null && value !== '') {
            this.setState({ lang: value });
        }
    }

    render() {
        return (<div>
            <Helmet>
                <title>Sacramentos Basílica Menor de Nuestra Se&ntilde;ora de Coromoto</title>
                <meta name="description" content="Sacramentos Basílica Menor de Nuestra Se&ntilde;ora de Coromoto" />
                <meta name="keywords" content="sacramentos, santuario, basilica, coromoto" />
            </Helmet>
            <Header />
            <SanctuaryHistorySlider />
            <div className="container">
                <div className="row">
                    <div className="col-12">&nbsp;</div>
                </div>

                <div className="row">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-header"><h3>Sacramento del Bautismo</h3>
                            </div>
                            <div className="card-body">
                                <div class="row">
                                    <div className="col-12">
                                        <article>
                                            <p>El santo Bautismo es el fundamento de&nbsp;toda la vida cristiana, el p&oacute;rtico de la vida en el&nbsp;esp&iacute;ritu (&quot;vitae spiritualis ianua&quot;) y la puerta que abre&nbsp;el acceso a los otros sacramentos. Por el Bautismo somos&nbsp;liberados del pecado y regenerados como hijos de Dios,&nbsp;llegamos a ser miembros de Cristo y somos incorporados a&nbsp;la Iglesia y hechos part&iacute;cipes de su misi&oacute;n.</p>
                                            <p>Este sacramento recibe el nombre de&nbsp; Bautismo en raz&oacute;n del car&aacute;cter del rito central mediante&nbsp; el que se celebra: bautizar (baptizein en griego)&nbsp;significa &quot;sumergir&quot;, &quot;introducir dentro del agua&quot;; la&nbsp;&quot;inmersi&oacute;n&quot; en el agua simboliza el acto de sepultar al&nbsp;catec&uacute;meno en la muerte de Cristo, de donde sale por la&nbsp;resurrecci&oacute;n con &Eacute;l (cf Rm 6,3-4; Col 2,12) como &quot;nueva&nbsp;criatura&quot; (2 Co 5,17; Ga 6,15).</p>
                                            <p><strong>Requisitos para el Sacramento del Ba</strong><strong>utismo</strong></p>
                                        </article>
                                    </div>
                                    <div className="col-12" align="center"> <img className="img-thumbnail" src={sacramentoBautismo} alt='Sacramento Bautismo Basílica Menor Santuario Nacional Nuestra Señora de Coromoto' /></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-12">&nbsp;</div>
                </div>
                <div className="row">
                    <div className="card">
                        <div className="card-header"><h3>Sacramento del Matrimonio</h3>
                        </div>
                        <div className="card-body">
                            <div class="row">
                                <div className="col-12">
                                    <article>
                                        <p>&quot;La alianza matrimonial, por la que el&nbsp;var&oacute;n y la mujer constituyen entre s&iacute; un consorcio de&nbsp;toda la vida, ordenado por su misma &iacute;ndole natural al&nbsp;bien de los c&oacute;nyuges y a la generaci&oacute;n y educaci&oacute;n de la&nbsp; prole, fue elevada por Cristo Nuestro Se&ntilde;or a la dignidad&nbsp;de sacramento entre bautizados&quot;.</p>
                                        <p><strong>Requisitos para el Sacramento del Matrimonio&nbsp; </strong></p>
                                    </article>
                                </div>
                                <div className="col-12" align="center"> <img className="img-thumbnail" src={sacramentoMatrimonio} alt='Sacramento Matrimonio Basílica Menor Santuario Nacional Nuestra Señora de Coromoto' /></div>
                            </div>
                        </div>
                    </div>

                </div>



            </div>
            <Footer />
        </div>);
    }

}